export default [
  {
    path: 'users',
    name: 'users',
    component: () => import(/* webpackChunkName: "users" */ './Index.vue'),
    meta: {
      title: 'Usuários',
      icon: 'mdi-account-group',
      admin: true
    },
    children: [
      {
        path: 'users/new',
        name: 'users.new',
        component: () => import(/* webpackChunkName: "users" */ './New.vue'),
      }
    ]
  },
  {
    path: 'users/:id',
    name: 'users.edit',
    component: () => import(/* webpackChunkName: "users" */ './Edit.vue'),
    meta: {
      title: 'Usuário',
      icon: 'mdi-account-group',
      admin: true
    }
  }
];
